import React from 'react';
import { Route } from 'react-router-dom';
import { faq, folders } from '~/config/routes';
import Home from './Home';
import Folders from './Folders';
import { FaqProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Faq() {
  return (
    <FaqProvider>
      <>
        <Route
          exact
          path={folders.spec}
          render={(props) => (
            <>
              <Can I="folders" a="Faqs">
                {() => <Folders {...props} />}
              </Can>
              <Can not I="folders" a="Faqs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={faq.spec}
          render={(props) => (
            <>
              <Can I="home" a="Faqs">
                {() => <Home {...props} />}
              </Can>
              <Can not I="home" a="Faqs">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </>
    </FaqProvider>
  );
}
export default Faq;
